import React, {FC, useEffect, useState} from 'react';
import {useClient} from "../../providers/ClientProvider";
import {Button, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {useHistory} from 'react-router-dom';
import {ClientPortalContainer} from "../../components/layout/ClientPortalContainer";
import {VerticalGap} from "../../components/layout/VerticalGap";
import * as api from "../../services/api";
import {auth} from "../../services/firebase/firebaseCore";
import {useUI} from "../../services/ui/UIProvider";
import { validatePassword } from 'tlm-common';
import firebase from "firebase/app";
import {toast} from "react-toastify";


export const AccountManagementPage: FC = () => {
  const {client} = useClient();
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [pwd, setPwd] = useState<string>('');
  const [pwd1, setPwd1] = useState<string>('');
  const [pwd2, setPwd2] = useState<string>('');
  const [passwordOK, setPasswordOK] = useState(false);
  const { showLoader } = useUI();

  const history = useHistory();

  useEffect(() => {
    if (client){
      setFirstName(client?.firstName);
      setLastName(client?.lastName);
    }
  }, [client]);

  const handleNameChange = async () => {
    try {
      showLoader(true);
      await api.clients.changeName(firstName, lastName);
      await auth.currentUser!.updateProfile({ displayName: `${firstName} ${lastName}`});
      toast.success('Name changed!');
    } catch (e) {
      toast.error(e.message);
    } finally {
      showLoader(false);
    }
  }

  const handlePwdChange = async () => {
    try {
      showLoader(true);
      const user = auth.currentUser;
      const credential = firebase.auth.EmailAuthProvider.credential(
        user!.email!,
        pwd
      );
      await user!.reauthenticateWithCredential(credential);
      await auth.currentUser!.updatePassword(pwd1);
      toast.success('Password changed!');
      setPwd('');
      setPwd1('');
      setPwd2('');
    } catch (e) {
      toast.error(e.message);
    } finally {
      showLoader(false);
    }
  }

  const showPwd1Invalid = pwd1.length > 1 && !validatePassword(pwd1);
  const passwordsGood = validatePassword(pwd1) && (pwd1===pwd2);

  return (
    <ClientPortalContainer>
      <VerticalGap gapSize={30}/>
      <Container>
        <Row>
          <Col>
            <h2 className="mb-4">Account Management</h2>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={6}>
            <div className="shadow p-4">
              <h4>Name</h4>
              <Form className="mt-0">
                <Form.Group controlId="formBasicEmail">
                  {/*<Form.Label>Email Address</Form.Label>*/}
                  <Form.Control
                    type="text"
                    placeholder="first name"
                    onChange={event => {
                      setFirstName(event.target.value)
                    }}
                    value={firstName}/>
                </Form.Group>
                <Form.Group controlId="formBasicPassword">
                  {/*<Form.Label>Password</Form.Label>*/}
                  <Form.Control
                    type="text"
                    placeholder="last name"
                    onChange={event => {
                      setLastName(event.target.value)
                    }}
                    value={lastName}/>
                </Form.Group>
              </Form>
              <Button variant="outline-primary"
                      size="sm"
                      onClick={handleNameChange}
                      disabled={ !(firstName && lastName) }
                      className="mb-3 mt-3">
                change name
              </Button>
            </div>
          </Col>
          <Col sm={12} md={6}>
            <div className="shadow p-4">
              <h4>Password</h4>
              <Form className="mt-0" noValidate validated={passwordOK}>
                <Form.Group>
                  <Form.Control
                    type="password"
                    placeholder="current password"
                    onChange={event => {
                      setPwd(event.target.value)
                    }}
                    value={pwd}/>
                </Form.Group>
                <Form.Group controlId="formBasicPassword">
                    <Form.Control
                      type="password"
                      placeholder="new password"
                      isInvalid={showPwd1Invalid}
                      onChange={event => {
                        setPwd1(event.target.value)
                      }}
                      value={pwd1}/>
                    <Form.Control.Feedback type="invalid">
                      Password must be at least 8 characters and include at least one uppercase letter, one lowercase letter, and one number.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formBasicPassword">
                  <Form.Control
                    type="password"
                    placeholder="new password again"
                    isInvalid={pwd1!==pwd2 && pwd.length < 7}
                    onChange={event => {
                      setPwd2(event.target.value)
                    }}
                    value={pwd2}/>
                  <Form.Control.Feedback type="invalid">
                    Passwords must match.
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
              { passwordsGood && <p className="text-success ml-3">✅ Good to go!</p> }
              <Button variant="outline-primary"
                      size="sm"
                      className="mb-3 mt-3"
                      disabled={!passwordsGood}
                      onClick={handlePwdChange}
              >
                change password
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </ClientPortalContainer>
  );
};


